export const WISHLIST_UUID_REQUEST = 'WISHLIST_UUID_REQUEST';
export const UPDATE_WISHLIST = 'UPDATE_WISHLIST';
export const WISHLIST_REQUEST = 'WISHLIST_REQUEST';
export const UUID_TO_SLUGS = 'UUID_TO_SLUGS';
export const ADD_SLUG = 'ADD_SLUG';
export const USE_LOCAL_STORAGE = 'USE_LOCAL_STORAGE';
export const DATA_FROM_UUID = 'DATA_FROM_UUID';
